var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4801"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631361",
    x: 0.8125,
    y: 9.75433,
    width: 14.375,
    height: 4.6327,
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 705",
    d: "M3.06073 14.3188L3.06073 12.7178",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 708",
    d: "M5.49631 14.3189L5.49631 11.8322",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 709",
    d: "M10.5718 14.3189L10.5718 11.8322",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 706",
    d: "M7.92749 14.3188L7.92749 12.7178",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 707",
    d: "M13.1393 14.3188L13.1393 12.7178",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 710",
    d: "M0.8125 1.61298V6.92696",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 712",
    d: "M12.9733 4.26996L2.54975 4.26996",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 711",
    d: "M15.1875 1.61298V6.92696",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 14",
    d: "M1.28937 4.27006L3.63978 2.70196L3.63978 5.83816L1.28937 4.27006Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 15",
    d: "M14.7062 4.06563L12.3558 5.63374L12.3558 2.49753L14.7062 4.06563Z",
    fill: "#626262"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.464636e286796900380ed6d872ee49dd.svg";
export { ForwardRef as ReactComponent };